import { FC, ReactNode } from 'react';

import * as Styles from './pill.styles';

type PillProps = {
  children: ReactNode;
  handler?: () => void;
}

const Pill: FC<PillProps> = ({ children, handler }) => {
  return (
    <Styles.Pill
      $hasHover={Boolean(handler)}
      onClick={handler}
    >
      {children}
    </Styles.Pill>
  );
};

export default Pill;
